import { shrpaApi } from "./axios";

// Types
import { BookDemoSubmitReturnType, RequestADemoFormData } from "@contracts/requestADemoForm";

export default {
  async getAllOrganizationTypes(): Promise<Array<string>> {
    const uri = "/leads/organization-types";
    const { data } = await shrpaApi.get<Array<string>>(uri);

    return data;
  },

  async requestADemo(formDataPayload: RequestADemoFormData): Promise<BookDemoSubmitReturnType> {
    const { data } = await shrpaApi.post<BookDemoSubmitReturnType>(`/leads/book-demo`, JSON.stringify(formDataPayload), { headers: { "Content-Type": "application/json" } });
    return data;
  },
};
